<template>

<div class="edit">

    <div class="edit-head">

        <app-icon icon="close" class="edit-head-back" v-tooltip="'Close modal'" v-on:click.native="onCloseClick" />

        <div class="edit-head-title">Add section</div>

        <div class="edit-head-actions">

            <app-page-head-action icon="tick" :disabled="!isValid" tooltip="Confirm" v-on:click.native="onConfirmClick" />

        </div>

    </div>

    <div class="edit-body">

        <app-input-text v-model="model.name" maxlength="32" :validation="$v.model.name" label="Name" placeholder="Enter name" />
        
        <app-input-text v-model="model.description" :autogrow="true" label="Description" placeholder="Enter description" notes="Optional - explain the purpose of the section and any other useful guidance." />

        <app-input-toggle v-model="model.locked" :fullWidth="true" label="Permissions" :options="lockOptions" v-if="isAdmin" />

        <app-input-toggle v-model="model.enabled" :fullWidth="true" label="Visibility" :options="enabledOptions" />

        <app-input-checklist :multiple="true" :stacked="true" v-model="model.types" :fullWidth="true" label="Allowed Blocks" :options="typeOptions" notes="Restrict the types of blocks a user can add to this section. Selecting no types will mean they cannot add new blocks." v-if="isAdmin" />
    
    </div>

</div>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {

	mixins: [validationMixin],

    props: ['item', 'isAdmin'],

    data: function() {

        return {
            enabledOptions: {
                1: 'Shown to users',
                0: 'Hidden from users',
            },
            lockOptions: {
                0: 'Can edit & remove',
                1: 'Can edit only',
                2: 'Locked' 
            },
			typeOptions: [
				{ value: 2, text: 'Group Name', icon: 'text.type.2' },
				{ value: 11, text: 'Paragraph', icon: 'text.type.11' },
				{ value: 1, text: 'Heading', icon: 'text.type.1' },
				{ value: null },
				{ value: 19, text: '"Lightbulb" bullet', icon: 'text.type.19' },
				{ value: 3, text: '"No" bullet', icon: 'text.type.3' },
				{ value: 7, text: '"Pin" bullet', icon: 'text.type.7' },
				{ value: 5, text: '"Star" bullet', icon: 'text.type.5' },
				{ value: 18, text: '"Stop" bullet', icon: 'text.type.18' },
				{ value: 16, text: '"Thumb" bullet', icon: 'text.type.16' },
				{ value: 17, text: '"Trash" bullet', icon: 'text.type.17' },
				{ value: 4, text: '"Yes" bullet', icon: 'text.type.4' },
				{ value: 14, text: '"Yes" columns', icon: 'text.type.14' },
				{ value: null },
				{ value: 6, text: 'Add Location...', icon: 'text.type.6' },
				{ value: 10, text: 'Add Image...', icon: 'text.type.10' },
				{ value: 12, text: 'Add Embed...', icon: 'text.type.12' },
				{ value: 9, text: 'Link to Group...', icon: 'text.type.9' },
				{ value: null },
				{ value: 13, text: 'Phone', icon: 'text.type.13' },
				{ value: 8, text: 'Website', icon: 'text.type.8' },
				{ value: 21, text: 'Email', icon: 'text.type.21' },
				{ value: 20, text: 'Address', icon: 'text.type.20' },
				{ value: 22, text: 'Hours', icon: 'text.type.22' },
				{ value: 15, text: 'Accepted Items', icon: 'text.type.15' },
			],
            model: {
                id: '',
                name: '',
                blocks: [],
                locked: 0,
                enabled: 1,
                types: []
            }
        }

    },

	validations: function() {
		
        var validations = {
            model: {
                name: {
                    required,
                    maxLength: maxLength(32)
                },
                description: {}
            }
        }

        return validations 

	},

    created: function() {

        if (this.$_.isObject(this.item)) {

            this.model = this.$util.clone(this.item)

        } else {

            if (!this.isAdmin) {

                this.$_.each(this.typeOptions, function(text, key) {

                    this.model.types.push(parseInt(key))

                }.bind(this))

            }

        }

    },

    computed: {

        isValid: function() {

			return !this.$v.$invalid

		}

    },

    methods: {

        onConfirmClick: function() {

            this.$emit('confirm', this.model)

        },

        onCloseClick: function() {

            this.$emit('close')

        }

    }

}

</script>

<style scoped>

.edit {
    position: fixed;
    left: 662px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    padding: 20px 40px;
    background-color: #fff;
    z-index: 1000;
    overflow: auto;
    box-shadow: inset 10px 0 15px -3px rgba(0, 0, 0, .1);
}

.edit-head {
	display: flex;
	align-items: center;
}

.edit-head-back {
	font-size: 24px;
	margin-right: 20px;
	flex-shrink: 0;
	color: #0b234e;
	cursor: pointer;
}

.edit-head-title {
    font-size: 24px;
    font-weight: 400;
    flex-grow: 1;
    color: #0b234e;
}

.edit-head-actions {
	display: flex;
	flex-shrink: 0;
	justify-content: flex-end;
}

.edit-body {
    padding: 50px 0px 0px 0px;
}

</style>